import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index: string
    children: ReactNode
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ index, children, className }): ReactNode => {
    return (
        <p className={cn('flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.24em]', className)}>
            <span className='tabular-nums'>
                {index}
            </span>

            <span aria-hidden='true' className='h-px w-8 bg-current opacity-40' />

            <span>
                {children}
            </span>
        </p>
    )
}
